<template>
    <div v-bind:class="{ bottom: data.bottom, opened: data.opened }" class="kebab-menu" ref="menu" @click.stop="onToggle">
        <slot name="trigger">
            <IconButton
                :name="props.name"
                :icon="props.icon"
                :sprite="props.sprite"
                :class="{
                    secondary: props.secondary,
                    tertiary: props.tertiary,
                    invert: props.invert,
                    'size-xl': props.size === 'size-xl',
                    'size-l': props.size === 'size-l',
                    'size-m': props.size === 'size-m',
                    'size-s': props.size === 'size-s',
                    active: data.opened
                }"
            />
        </slot>

        <ModalBox v-if="data.opened"
            :field="menu"
            :placeOptions="{
                leftAuto: props.leftAuto,
                rightAuto: props.rightAuto,
                offset: 8
            }"
            size="size-l"
            @close="close"
            @onClick="onToggle"
            @onSwipeBottom="close"
        >
            <slot />
        </ModalBox>
    </div>
</template>

<script setup>
import { reactive, ref } from 'vue';
import IconButton from '🔗/components/ui/IconButton.vue';
import ModalBox from '🔗/components/ui/ModalBox.vue';

const props = defineProps({
    icon: { type: String, default: 'more-vertical' },
    sprite: { type: String, default: 'navigation' },
    name: { type: String, default: '' },
    leftAuto: { type: Boolean, default: true },
    rightAuto: { type: Boolean, default: false },
    tertiary: { type: Boolean, default: false },
    invert: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    secondary: { type: Boolean, default: false },
    size: { type: [String, null], default: null }
});

const emit = defineEmits(['toggle']);
const menu = ref();

const data = reactive({
    opened: false
});

const close = (e) => {
    data.opened = !data.opened;
    emit('toggle', data.opened);
}

const onToggle = (e) => {
    if (props.disabled) {
        return;
    }

    if (data.opened && e.target.nodeName === 'UL') {
        return;
    }

    data.opened = !data.opened;

    emit('toggle', data.opened);

    if (!data.opened) {
        return false;
    }
};

const show = () => {
    if (!data.opened) {
        onToggle();
    }
};

defineExpose({
    show,
    close
});
</script>

<style lang="scss">
</style>
